export default "__VITE_ASSET__SfcEhugy__"